import { AbstractTestDisplayProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractTestDisplayProperties";
import { GridLayout } from "@lib/titan2/dist/game/control/layout/GridLayout";
/**
 * TestDisplayProperties.ts
 */
export class TestDisplayProperties extends AbstractTestDisplayProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.panelProperties.layout = new GridLayout(10, 4, 5, 5);
    }
}
//# sourceMappingURL=TestDisplayProperties.js.map